import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "dropdown-reference",
  contenteditable: "false"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Command = _resolveComponent("Command")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    ref: "dropdown",
    class: "suggestions-dropdown",
    contenteditable: "false",
    placement: "top-start",
    trigger: "click",
    "hide-on-click": false,
    teleported: true,
    "popper-class": "chats-dropdown-edit",
    persistent: false,
    "popper-options": {modifiers: [{name: 'offset', options: { offset: [0, 20] }}]},
    onVisibleChange: _cache[0] || (_cache[0] = $event => ($data.visible = $event)),
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, {
        class: "prompt-items-menu",
        onPointerdown: _withModifiers($options.keepFocus, ["prevent","stop"]),
        onMousedown: _withModifiers($options.keepFocus, ["prevent","stop"]),
        onMouseenter: $options.keepFocus,
        onMousemove: $options.keepFocus,
        onFocusin: $options.keepFocus
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_Command, {
              key: item.command,
              active: index === $data.active_idx,
              item: item,
              onMouseenter: $event => ($data.active_idx = index),
              onClick: $event => (_ctx.$emit('select', item))
            }, null, 8 /* PROPS */, ["active", "item", "onMouseenter", "onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onPointerdown", "onMousedown", "onMouseenter", "onMousemove", "onFocusin"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        ($options.is_empty)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("  Type to filter ")
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}